import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from "react";

var SvgWescircle = function SvgWescircle(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 390 390"
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 251,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.3 72.8c-.5-3.2-2.8-5.8-5.9-6.6-11.2-2.9-28.9-6.5-50.4-7.8-4.6-.3-8.5 3.4-8.5 8v20c0 4.3 3.3 7.8 7.6 8 21.2 1.2 40.5 4.7 56.1 8.4 2.8.7 5.3-1.7 4.9-4.5l-3.8-25.5zM268.9 360H121.1l-8.1 12c24.9 11.6 52.7 18 82 18s57.1-6.5 82-18l-8.1-12zM187.5 86.4v-20c0-4.6-3.9-8.3-8.5-8-21.6 1.3-39.2 4.9-50.4 7.7-3.1.8-5.5 3.4-5.9 6.6l-3.8 25.6c-.4 2.8 2.1 5.1 4.9 4.5 15.6-3.8 34.9-7.2 56.1-8.4 4.3-.2 7.6-3.7 7.6-8z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 251,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 0C87.3 0 0 87.3 0 195c0 69.8 36.7 131 91.8 165.5l40.8-60.5-39.2-28c-5.3-3.8-8.4-9.8-8.4-16.3v-48V129c0-8.6 5.5-16.3 13.7-19 1.1-.4 2.3-.8 3.5-1.1l5.7-38.3c1.4-9.1 8-16.6 17-18.9 14.9-3.8 39.8-8.7 70.1-8.7s55.3 4.9 70.1 8.7c9 2.3 15.6 9.8 17 18.9l5.7 38.3c1.2.4 2.4.8 3.5 1.1 8.2 2.7 13.7 10.4 13.7 19V255.7c0 6.5-3.1 12.5-8.4 16.3l-39.2 28 40.8 60.5C353.3 326 390 264.8 390 195 390 87.3 302.7 0 195 0zm-12 37c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zm24 0c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.1 344l-9.4-14H141.3l-9.4 14z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 127,
    r: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.1 314h85.8l-9.5-14h-66.8z"
  }));
};

export default SvgWescircle;
//# sourceMappingURL=WesCircle.js.map